const template = (data) => `
    <option value="${data.id}" ${data.selected ? 'selected' : ''}>
        ${data.name}
    </option>`

export default template
